import * as React from "react";
import { AutocompleteInput, useInput, useReferenceInputController } from "react-admin";

export const ProductArticleInput = ({ onChange, size, ...props }) => {
	const { companyId, source } = props;
	const { input } = useInput(props);
	const filter = React.useMemo(() => ({ company_id: companyId }), [companyId]);
	const sort = React.useMemo(() => ({ field: "product_name", order: "ASC" }), []);

	const { choices, setFilter, loading, loaded } = useReferenceInputController({
		...props,
		input,
		reference: "product-articles",
		filter,
		sort,
		perPage: 50,
	});

	const prevIdRef = React.useRef(input.value);

	React.useEffect(() => {
		if (prevIdRef.current !== input.value && onChange) {
			const record = choices.find((c) => c.id === input.value) || null;
			onChange(record);
		}
		prevIdRef.current = input.value;
	}, [input.value, choices, onChange]);

	const optionTextRender = React.useCallback(
		(record) => (record ? `${record.product_name} / ${record.product_number}` : ""),
		[]
	);

	return (
		<AutocompleteInput
			source={source}
			optionText={optionTextRender}
			choices={choices}
			setFilter={setFilter}
			loading={loading}
			loaded={loaded}
			resettable
			fullWidth
			options={{ InputProps: { size } }}
		/>
	);
};
